module.exports = __webpack_public_path__ + "96CDE27BE6A761F15653E5A1B5B5BF91add.4c4ce2b5.png";